import React, { useContext, useEffect, useState } from "react";
import styles from "./styles/PosCashOp.module.css";
import POSDataContext from "../../../context/POSDataContext";
import DataContext from "../../../context/DataContext";
import { useNavigate, useParams } from "react-router-dom";
import Spinner from "../../../components/ui/spinner/Spinner";
import PosCashOpForm from "./PosCashOpForm";

/**
 * The cash operations page for the POS system.
 */
const PosCashOp = () => {
    const {
        isLoadingPos, // {Boolean} - Indicates whether data is being loaded.
    } = useContext(POSDataContext);

    const { bUser } = useParams(); // Extracts 'bUser' parameter from the URL.

    const {
        isServiceDataAvailable, // {Bolean} - Flag indicates if service data is avialable for the current user
        serviceData, // {Function} - Fetch the service data
        currentBU, // {String} - The current business user
        isLoading,
        JWTToken,
    } = useContext(DataContext);
    const [notReadyView, setNotReadyView] = useState(true);
    const navigate = useNavigate(); // Hook for navigation in React Router.

    // Redirects to the POS page if the currentBU is not available.
    // usually this happens when copying the URL and pasting it in a new tan in the browser.
    useEffect(() => {
        if (!currentBU) {
            navigate(`/${bUser}/pos`);
        }
    }, [bUser, currentBU]);

    // Fetches the service data if the business user has changed.
    useEffect(() => {
        bUser &&
            JWTToken &&
            (!isServiceDataAvailable || bUser !== currentBU) &&
            serviceData(bUser);
    }, [bUser, isServiceDataAvailable, JWTToken]);

    // Check ready for viewing
    useEffect(() => {
        if (isServiceDataAvailable && (!isLoadingPos || !isLoading)) {
            const timer = setTimeout(() => {
                setNotReadyView(false);
            }, 50);

            // Cleanup function
            return () => {
                clearTimeout(timer);
            };
        }
    }, [isServiceDataAvailable, isLoadingPos, isLoading]);

    return (
        <article
            className={`${styles.main_page_wrapper} transition-container 
                    ${
                        notReadyView
                            ? "transition-hidden"
                            : "transition-visible"
                    }  main-page-container flex-container`}
        >
            {!isServiceDataAvailable || isLoadingPos ? (
                <Spinner />
            ) : (
                <main
                    className={`${styles.main_cashop_container} main-container flex-container`}
                >
                    <PosCashOpForm />
                </main>
            )}
        </article>
    );
};

export default PosCashOp;
